export default __webpack_public_path__ + "static/media/FA_Logo_gray.5bda4ba1.png";